import { CustomerState } from './state';
import { CustomerAction, CustomerActions, CustomerSetCustomerDetail, CustomerAcceptDisclaimer, CustomerSetOtpData } from './action';
import { CustomerIdType } from '../../models/customer/idType';

export const customerInitial: CustomerState = {
    id: '',
    idType: CustomerIdType.Unknown,
    acceptDisclaimer: false,
    mobileNumber: '',
    token: '',
    reference: '',
};

export function customerReducer(state: CustomerState = customerInitial, action: CustomerActions) {
    switch (action.type) {
        case CustomerAction.SetCustomerDetail:
            const actSetCustomerDetail: CustomerSetCustomerDetail = action as CustomerSetCustomerDetail;

            return {
                ...state,
                id: actSetCustomerDetail.value.id,
                idType: actSetCustomerDetail.value.type,
                mobileNumber: actSetCustomerDetail.value.mobileNumber,
                token: actSetCustomerDetail.value.token,
                reference: actSetCustomerDetail.value.reference,
            };
        case CustomerAction.SetAcceptDisclaimer:
            const actSetAcceptDisclaimer: CustomerAcceptDisclaimer = action as CustomerAcceptDisclaimer;

            return {
                ...state,
                acceptDisclaimer: actSetAcceptDisclaimer.value.isAccept,
            };
        case CustomerAction.SetOtpData:
            const actSetOtpData: CustomerSetOtpData = action as CustomerSetOtpData;

            return {
                ...state,
                token: actSetOtpData.value.token,
                reference: actSetOtpData.value.reference,
            };
      default:
        return state;
    }
}